import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Reports from '../components/reports';
import { switchReportTabs } from '../../common/actions/ui-state-action-creators';
import { tabIndexSelector } from '../selectors/reports-selectors';
import { reportMap } from '../constants/reports';

export class ReportsContainer extends Component{
    handleTabChange = ( event, index ) => {
        const { match: { params: { reportId } } } = this.props;
        this.props.switchReportTabs( index, reportId );
    };

    render(){
        const { reportTabIndex, match } = this.props;

        return (
            <Reports
                handleTabChange={this.handleTabChange}
                reportTabIndex={reportTabIndex}
                reportMap={reportMap}
                match={match}
            />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        reportTabIndex: tabIndexSelector( state )
    };
};

ReportsContainer.propTypes = {
    match: PropTypes.shape( {
        params: PropTypes.object
    } ),
    reportTabIndex: PropTypes.number.isRequired,
    switchReportTabs: PropTypes.func.isRequired,
};

export default connect( mapStateToProps, { switchReportTabs } )( ReportsContainer );
